import script from "./TestCaseDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./TestCaseDetail.vue?vue&type=script&setup=true&lang=js"

import "./TestCaseDetail.vue?vue&type=style&index=0&id=1df160e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1df160e2"]])

export default __exports__